<template>
    <LayoutHelp>
        <template v-slot:searchbox>
            <SearchBox />
        </template>
        <template v-slot:content>
            <div class="mm-section__faq-topic mm-section__faq-topic--full-width"
                v-if="data">
                <div class="mm-section__faq-topic-header">
                    <div class="box box--space-vertical">
                        <router-link :to="localeRoute('help')"
                            class="mm-link mm-link--icon-left-space-s">
                            <i class="icon icon-arrow-left"></i> {{$t('helpPage.backToList')}}
                        </router-link>
                    </div>

                    <span v-if="tagLabel" class="mm-section__faq-category">
                        {{tagLabel}}
                    </span>
                    <span class="headline headline--third headline--colored">
                        {{data.title}}
                    </span>
                </div>
                <div class="mm-section__faq-detial box--space-top text--basic-paragraph">
                    <div v-html="data.content"></div>
                </div>
            </div>
        </template>
    </LayoutHelp>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import webCMS from '@/services/WebCMS';
import SearchBox from '@/components/help/search';
import LayoutHelp from '@/components/layouts/Help';
import { getTranslationIdForTagList } from '@/components/help/utils';

export default {
    components: {
        SearchBox,
        LayoutHelp
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadData();
    },
    data() {
        return {
            data: null
        };
    },
    watch: {
        '$route.params.id': function () {
            this.data = null;
            this.loadData();
        }
    },
    methods: {
        loadData() {
            webCMS.getPageBySeoId(this.axios, {seoId: this.pageId})
                .then(res => {
                    this.data = res;
                });
        }
    },
    computed: {
        pageId() {
            return this.$route.params.id;
        },
        tagLabel() {
            if (this.data && this.data.tags) {
                return this.$t(getTranslationIdForTagList(this.data.tags));
            }

            return null;
        }
    }
}
</script>


<style lang="scss" scoped>
</style>
